module.exports = __webpack_public_path__ + "static/media/YF12_0.d171fb8e.jpg";